var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-row align-center tags-view-container" },
    [
      _c(
        "tab-scroll",
        { staticClass: "tags-view-wrapper flex flex-row align-center" },
        _vm._l(_vm.visitedViews, function (tag) {
          return _c(
            "div",
            {
              key: tag.url,
              staticClass:
                "tags-view-item cursor-pointer flex flex-row align-center",
              class: _vm.isActive(tag) ? "active" : "",
            },
            [
              _c("router-link", { attrs: { to: tag.url } }, [
                _vm._v(" " + _vm._s(tag.name) + " "),
              ]),
              tag.pCode !== ""
                ? _c("span", {
                    staticClass: "el-icon-close",
                    on: {
                      click: function ($event) {
                        return _vm.handleCloseTag(tag)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }